import React, { useState } from "react";
import { FaQuoteLeft, FaStar } from "react-icons/fa";

const testimonials = [
  {
    name: "Dhananjay Lenka",
    role: "Customer",
    image:
      "https://media.istockphoto.com/id/1136413215/photo/young-man-at-street-market.jpg?s=612x612&w=0&k=20&c=obnaR5III0jRxHKd4ZPl3LRC2pI792KbHYR2eBzKKe8=",
    rating: 5,
    text: "High-quality bricks and fast delivery — couldn’t ask for more. Highly recommend BrickNBar for construction materials.",
  },
  {
    name: "Neha Mohanty",
    role: "Customer",
    image:
      "https://plus.unsplash.com/premium_photo-1723568666044-1b066e26b1fb?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8aW5kaWFuJTIwcGVyc29ufGVufDB8fDB8fHww",
    rating: 4,
    text: "Ordered electrical switches and fittings — great quality and prompt delivery. BrickNBar is now my go-to site.",
  },
  {
    name: "Rajiv Pradhan",
    role: "Customer",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxDuiTSnPXEDZux5NEHgARnBrCISyawSteAw&s",
    rating: 5,
    text: "It’s so convenient to find all construction and interior items in one place. BrickNBar saved me countless trips to stores!",
  },
  {
    name: "Priya Kumari Sahoo",
    role: "Customer",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ72FBQLR2bgffyuceXXqdOtWHIANdQbFt4mA&s",
    rating: 5,
    text: "Shopping on BrickNBar was smooth and easy. I could compare products and prices from home.",
  },
  {
    name: "Manish Das",
    role: "Customer",
    image:
      "https://thumbs.dreamstime.com/b/serious-determined-indian-man-shot-outdoors-person-can-also-represent-latin-mexican-male-businessman-executive-46577677.jpg",
    rating: 4,
    text: "BrickNBar combines variety, affordability, and quality. It’s my one-stop-shop for all building materials now.",
  },
];

const Testimonials = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const testimonialsPerPage = 3;

  const totalPages = Math.ceil(testimonials.length / testimonialsPerPage);
  const startIndex = (currentPage - 1) * testimonialsPerPage;
  const currentTestimonials = testimonials.slice(
    startIndex,
    startIndex + testimonialsPerPage
  );

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 bg-white">
      <h2 className="text-3xl font-bold mb-6">Client Testimonials</h2>

      <div className="grid md:grid-cols-3 gap-6">
        {currentTestimonials.map((t, index) => (
          <div
            key={index}
            className="border rounded-lg p-6 shadow-sm bg-white hover:shadow-md transition"
          >
            <FaQuoteLeft className="text-orange-700 text-3xl mb-4" />
            <p className="text-gray-600 mb-6 text-sm">{t.text}</p>
            <div className="flex items-center gap-4">
              <img
                src={t.image}
                alt={t.name}
                className="w-10 h-10 rounded-full"
              />
              <div>
                <h4 className="text-sm font-semibold">{t.name}</h4>
                <p className="text-xs text-gray-400">{t.role}</p>
              </div>
              <div className="ml-auto flex text-orange-400">
                {[...Array(t.rating)].map((_, i) => (
                  <FaStar key={i} />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination Controls */}
      <div className="flex justify-center items-center mt-8 gap-4">
        <button
          onClick={handlePrev}
          disabled={currentPage === 1}
          className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
        >
          Previous
        </button>
        <span className="text-sm font-medium">
          Page {currentPage} of {totalPages}
        </span>
        <button
          onClick={handleNext}
          disabled={currentPage === totalPages}
          className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Testimonials;
